import SuburbPestControlPage from "../components/SuburbPestControlPage";
import { IPSWICH_SUBURBS } from "../data/ipswichSuburbs";

export default function PestControlYamantoPage() {
  return <SuburbPestControlPage suburb={IPSWICH_SUBURBS["yamanto"]} />;
}
